import React from "react";
import { useParams, Link, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import blogData from "./Blogdata";

const BlogDetails = () => {
  const { id } = useParams();
  const blog = blogData[id];
  const location = useLocation();
  const currentUrl = window.location.origin + location.pathname;

  const copyAndOpen = (url) => {
    navigator.clipboard.writeText(currentUrl).then(() => {
      window.open(url, "_blank");
    });
  };

  const encodedUrl = encodeURIComponent(currentUrl);

  if (!blog) return <div className="p-10">Blog not found.</div>;

  return (
    <div className="max-w-4xl mx-auto px-4 py-12 mt-28">
      <Helmet>
        <title>{blog.title} | Pixell Blog</title>
        <meta name="description" content={blog.description} />
        <meta name="keywords" content={blog.metaKeywords.join(", ")} />
      </Helmet>

      <img
        src={blog.image}
        alt={blog.title}
        className="rounded-lg mb-8 w-full max-h-[500px]"
      />
      <h1 className="text-3xl md:text-5xl font-bold text-[#1e293b] mb-4">
        {blog.title}
      </h1>

      <div className="flex items-center gap-3 mb-4">
        <div>
          <p className="font-semibold text-gray-800">{blog.author}</p>
          <p className="text-sm text-gray-500">{blog.date}</p>
        </div>
      </div>

      {/* Tags */}
      {/* <div className="mb-6 flex gap-2 flex-wrap">
        {blog.tags.map((tag, i) => (
          <span
            key={i}
            className="text-xs px-3 py-1 rounded-full bg-purple-100 text-purple-700 font-medium"
          >
            {tag}
          </span>
        ))}
      </div> */}

      {/* Content */}
      <div className="prose max-w-none text-gray-800 leading-7">
        {blog.content}
      </div>

      {/* Social sharing */}
      <div className="mt-10 border-t pt-6 flex items-center justify-between text-sm text-gray-500">
        <p>Share this article:</p>
        <div className="flex gap-4">
          <button
            className="hover:text-blue-500 flex items-center gap-1"
            onClick={() =>
              copyAndOpen(
                `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`
              )
            }
          >
            <FacebookIcon fontSize="small" />
          </button>
          <button
            className="hover:text-blue-400 flex items-center gap-1"
            onClick={() =>
              copyAndOpen(`https://twitter.com/intent/tweet?url=${encodedUrl}`)
            }
          >
            <TwitterIcon fontSize="small" />
          </button>
          <button
            className="hover:text-pink-500 flex items-center gap-1"
            onClick={() =>
              copyAndOpen(
                `https://www.linkedin.com/shareArticle?url=${encodedUrl}`
              )
            }
          >
            <LinkedInIcon fontSize="small" />
          </button>
          <button
            className="hover:text-green-500 flex items-center gap-1"
            onClick={() =>
              copyAndOpen(`https://api.whatsapp.com/send?text=${encodedUrl}`)
            }
          >
            <WhatsAppIcon fontSize="small" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default BlogDetails;
